import { Box, Container } from '@mui/material';
import React from 'react';
// import { Container } from '@material-ui/core';

const MainContent = ({ children }) => {
  return (
    <Box style={{ margin: 0, background: '#000000', minHeight: 'calc(100dvh - 1.25rem)', width: "100%" }}>
      {children}
    </Box>
  );
};

export default MainContent;
